import cx from 'classnames';
import { FC } from 'react';

import { Typography } from 'src/components-v2/DataDisplay';
import { Link } from 'src/components/Inputs';

import { List } from '../List';
import type { CardWIcon, Columns as TColumns, Link as TLink } from '../types';

import styles from './Columns.module.scss';

type ColumnsProps = {
  className?: string;
  items: TColumns['children'];
};

const isCardWIconArray = (
  children: TLink[] | CardWIcon[],
): children is CardWIcon[] => {
  return 'icon' in children[0];
};

export const Columns: FC<ColumnsProps> = ({ className, items }) => {
  const [firstColumn, secondColumn] = items;

  return (
    <div
      className={cx(styles.Columns, className, {
        [styles.Columns_links]: !isCardWIconArray(secondColumn.children),
      })}
    >
      <div className={styles.Column}>
        <Typography className={styles.Title} theme='main-menu-new' variant='h6'>
          {firstColumn.title}
        </Typography>

        <List className={styles.Column__list} items={firstColumn.children} />
      </div>

      <div
        className={cx(styles.Column, {
          [styles.Column_links]: !isCardWIconArray(secondColumn.children),
        })}
      >
        <Typography className={styles.Title} theme='main-menu-new' variant='h6'>
          {secondColumn.title}
        </Typography>

        {isCardWIconArray(secondColumn.children) ? (
          <List className={styles.Column__list} items={secondColumn.children} />
        ) : (
          <ul className={styles.List}>
            {secondColumn.children.map((item, i) => {
              const { href, title, locale } = item;

              return (
                <li
                  className={styles.List__item}
                  key={`main-menu-column-item-${i}`}
                >
                  <Link href={href} locale={locale}>
                    <a className={styles.Link} role='link' tabIndex={-1}>
                      <Typography
                        theme='main-menu-new'
                        variant='p'
                        component='span'
                        sx={{
                          mb: 0,
                        }}
                      >
                        {title}
                      </Typography>
                    </a>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};
